module.exports = __webpack_public_path__ + "static/media/PRACTICA9.087a1d7e.jpeg";